








import { Vue, Component, Prop } from "vue-property-decorator";
import AppBar from "@/app-bar/AppBar.vue";
import AppContainer from "@/app-container/AppContainer.vue";
import AppDrawer from "@/app-drawer/AppDrawer.vue";

@Component({
    name: "App",
    components: {
        "app-bar": AppBar,
        "app-container": AppContainer,
        "app-drawer": AppDrawer
    }
})
export default class Home extends Vue {}
